<template>
  <div>
    <loader v-if="loading" />
    <div v-else-if="url === null">
      No E-Valuate instance found for this office.
    </div>
    <div v-else>
      <label for="url">URL:</label>
      <input type="text" id="url" v-model="url" class="block w-full bg-grey-lighter border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm mb-6" readonly>

      <p>Create a link to your E-Valuate instance on your website, by directing users to the URL above.</p>
    </div>
  </div>
</template>

<script>
import api from '@/http'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      url: null,
      loading: true
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  created () {
    this.fetchLinks()
  },
  methods: {
    fetchLinks () {
      this.loading = true
      if (!this.selectedOffice) {
        return
      }

      api.get('evaluate/links', {
        params: {
          officeID: this.selectedOffice.id
        }
      }).then((response) => {
        this.url = response.data.url
        this.loading = false
      })
    }
  },
  watch: {
    selectedOffice: {
      handler () {
        this.fetchLinks()
      },
      deep: true
    }
  }
}
</script>
